import { ChangeCartStoreResult } from '@spa/lib/graphql/cart/changeCartStore';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartStoreRequestedPayload {
  readonly actionId: number;
  readonly parentActionId: number;
  readonly storeCode: string;
}
export const apiCartChangeCartStoreRequestedType = 'api/cart/changeCartStore--requested';
export const apiCartChangeCartStoreRequested = createAction<ApiCartChangeCartStoreRequestedPayload>(
  apiCartChangeCartStoreRequestedType
);
export type ApiCartChangeCartStoreRequestedAction = ReturnType<
  typeof apiCartChangeCartStoreRequested
>;

export interface ApiCartChangeCartStoreSucceededPayload {
  readonly cartId: string;
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly result: ChangeCartStoreResult;
}
export const apiCartChangeCartStoreSucceededType = 'api/cart/changeCartStore--succeeded';
export const apiCartChangeCartStoreSucceeded = createAction<
  ApiCartChangeCartStoreSucceededPayload,
  typeof apiCartChangeCartStoreSucceededType
>(apiCartChangeCartStoreSucceededType);
export type ApiCartChangeCartStoreSucceededAction = ReturnType<
  typeof apiCartChangeCartStoreSucceeded
>;

export interface ApiCartChangeCartStoreFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly error: string | null;
}
export const apiCartChangeCartStoreFailedType = 'api/cart/changeCartStore--failed';
export const apiCartChangeCartStoreFailed = createAction<
  ApiCartChangeCartStoreFailedPayload,
  typeof apiCartChangeCartStoreFailedType
>(apiCartChangeCartStoreFailedType);
export type ApiCartChangeCartStoreFailedAction = ReturnType<typeof apiCartChangeCartStoreFailed>;
